import { Component } from '@angular/core';

@Component({
    selector: 'ups-home-layout',
    templateUrl: './home-layout.component.html',
    styleUrls: ['./home-layout.component.scss'],
    standalone: false
})
export class HomeLayoutComponent {
  constructor() {}
}
